module.exports = __webpack_public_path__ + "static/media/Documents.24363481.svg";